import { Grommet } from "grommet";
import React from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { EASTER_EGG } from "../config";
import { STORAGE_AUTH_TOKEN } from "../constants/storage";
import * as r from "../routes";
import { fetchSelfAsync, setAuthToken } from "../store/modules/user/actions";
import theme from "../theme";
import App from "./App";
import AuthenticatedRoute from "./AuthenticatedRoute";
import Calculator from "./Calculator";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import Onboarding from "./Onboarding";
import ResetPassword from "./ResetPassword";
import SignUp from "./SignUp";

Modal.setAppElement("#root");

type ContainerProps = {
  setAuthToken: (authToken: string) => void;
  fetchSelf: () => void;
};

type ContainerState = {};

class Container extends React.Component<ContainerProps, ContainerState> {
  constructor(props: ContainerProps) {
    super(props);
    const { setAuthToken } = props;
    const authToken = localStorage.getItem(STORAGE_AUTH_TOKEN);
    if (authToken) {
      setAuthToken(authToken);
    }
    console.log(EASTER_EGG);
  }

  render() {
    return (
      <Grommet full theme={theme} id="app-container">
        <Router>
          <Switch>
            <Route path={r.ROUTE_CALCULATOR}>
              <Calculator />
            </Route>
            <Route exact path={r.ROUTE_LOGIN}>
              <Login />
            </Route>
            <Route exact path={r.ROUTE_FORGOT_PASSWORD}>
              <ForgotPassword />
            </Route>
            <Route exact path={r.ROUTE_RESET_PASSWORD}>
              <ResetPassword />
            </Route>
            <Route exact path={[r.ROUTE_SIGN_UP, r.ROUTE_REGISTER]}>
              <SignUp />
            </Route>
            <AuthenticatedRoute path={r.ROUTE_ONBOARDING}>
              <Onboarding />
            </AuthenticatedRoute>
            {/* <AuthenticatedRoute path="/temp">
              <Screens />
            </AuthenticatedRoute> */}
            {/* <AuthenticatedRoute path={r.ROUTE_STYLES}>
              <Styles />
            </AuthenticatedRoute>
            <AuthenticatedRoute path={r.ROUTE_DASHBOARD}>
              <Dashboard />
            </AuthenticatedRoute> */}
            <AuthenticatedRoute path={r.ROUTE_APP}>
              <App />
            </AuthenticatedRoute>
            {/* <Route path={r.ROUTE_START}>
              <Start />
            </Route> */}
            {/* <Route path={r.ROUTE_ONBOARDING}>
              <Onboarding />
            </Route> */}
            {/* <AuthenticatedRoute path={r.ROUTE_ACCOUNT}>
              <Account />
            </AuthenticatedRoute> */}
            {/* <AuthenticatedRoute path={r.ROUTE_TFA_SETUP}>
              <TFASetup />
            </AuthenticatedRoute> */}
            {/* <AuthenticatedRoute path={r.ROUTE_DEPOSIT}>
              <Deposit />
            </AuthenticatedRoute>
            <AuthenticatedRoute path={r.ROUTE_RECURRING_DEPOSIT}>
              <RecurringDeposit />
            </AuthenticatedRoute> */}

            <Redirect to={r.ROUTE_APP} />
          </Switch>
        </Router>
        <ToastContainer />
      </Grommet>
    );
  }
}

export default connect(
  () => {
    return {};
  },
  (dispatch) => {
    return {
      setAuthToken: (authToken: string) => dispatch(setAuthToken(authToken)),
      fetchSelf: () => dispatch(fetchSelfAsync.request()),
    };
  }
)(Container);
